import { s3StaticImagePath } from ".";

export const partnersList = [
  "vakrangee",
  "fastpay",
  "comparewise",
  "gsunite",
  "moneychamp",
  "iwebtechno",
  "toshanipremium",
  "faydapay",
  "vakrangeegold",
  "askcredit",
  "lidservices",
  "paymonk",
  "jeevan-utthan",
  "inforts",
  "1touchpe",
  "ezeepay",
  "dirsti",
  "visitmyloan",
  "winoraa",
  "ygocompany",
  "nitya_finance",
  "daypfinance",
  "aadarsh_finance",
  "realzone",
  "moneyflow",
  "webpe",
  "viren",
  "moral-e-suvidha",
  "yoke",
  "indezon",
  "dhanvriddhiassurance",
  "fivekcr",
  "saralpe"
];

export const coBrandList = {
  carinfo: {
    logo: "https://creditlinks-lap.s3.ap-south-1.amazonaws.com/static/1740386309-carinfo.png",
  },
};

export const partners = {
  // "l" is not partners. it's define for default value of below property on main site version
  l: {
    logo: `${s3StaticImagePath}/1669802513-CreditLinks_blue_logo.webp`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap",
    fontFamily: "'Roboto', sans-serif",
    colors: {
      primary: "#4EC9DB",
      secondary: "#070050",
    },
    tancApply: false,
  },
  saralpe: {
    logo: `${s3StaticImagePath}/1669802513-CreditLinks_blue_logo.webp`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap",
    fontFamily: "'Roboto', sans-serif",
    colors: {
      primary: "#4EC9DB",
      secondary: "#070050",
    },
    tancApply: false,
  },
  comparewise: {
    logo: `${s3StaticImagePath}/1754651254-fsOFGg8W3v.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Poppins', sans-serif",
    colors: {
      primary: "#68CEA8",
      secondary: "#183d47",
    },
    tancApply: false,
  },
  vakrangee: {
    logo: `${s3StaticImagePath}/1754651281-49g1mnHU41.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
    fontFamily: "'Lato', sans-serif",
    colors: {
      primary: "#ED7725",
      secondary: "#000000",
    },
    tancApply: false,
  },
  fastpay: {
    logo: `${s3StaticImagePath}/1754651306-M4bVZgPsp7.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700;800;900&display=swap",
    fontFamily: "'Work Sans', sans-serif",
    colors: {
      primary: "#B32117",
      secondary: "#666666",
    },
    tancApply: false,
  },
  gsunite: {
    logo: `${s3StaticImagePath}/1754651334-2niW2VyYXi.jpeg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap",
    fontFamily: "'Open Sans', sans-serif",
    colors: {
      primary: "#047352",
      secondary: "#353692",
    },
    tancApply: false,
  },
  moneychamp: {
    logo: `${s3StaticImagePath}/1754651362-tRGJCfguIs.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Poppins', sans-serif",
    colors: {
      primary: "#25799d9e",
      secondary: "#004a80",
    },
    tancApply: false,
  },
  iwebtechno: {
    logo: `${s3StaticImagePath}/1754651388-CzVOFbu8KA.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap",
    fontFamily: "'Open Sans', sans-serif",
    colors: {
      primary: "#035fac",
      secondary: "#004a80",
    },
    title: "Need Money? Get Instant Credit With Your ID Card!*",
    tancApply: true,
  },
  toshanipremium: {
    logo: `${s3StaticImagePath}/1754651419-aIXlGBM4zA.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
    fontFamily: "'Lato', sans-serif",
    colors: {
      primary: "#E10000",
      secondary: "#004a80",
    },
    tancApply: false,
  },
  faydapay: {
    logo: `${s3StaticImagePath}/1754651456-NQDcjMmcaf.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap",
    fontFamily: "'Lato', sans-serif",
    colors: {
      primary: "#007bff",
      secondary: "#004a80",
    },
    tancApply: false,
  },
  vakrangeegold: {
    logo: `${s3StaticImagePath}/1754651281-49g1mnHU41.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
    fontFamily: "'Lato', sans-serif",
    colors: {
      primary: "#ED7725",
      secondary: "#000000",
    },
    tancApply: false,
  },
  askcredit: {
    logo: `${s3StaticImagePath}/1754651524-H7gHKpBHoz.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&display=swap",
    fontFamily: "'Lato', sans-serif",
    colors: {
      primary: "#3A5CBA",
      secondary: "#000000",
    },
    tancApply: false,
  },
  lidservices: {
    logo: `${s3StaticImagePath}/1754651557-s8Log5qhPs.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Jost', sans-serif",
    colors: {
      primary: "#006633",
      secondary: "#212529",
    },
    tancApply: false,
  },
  paymonk: {
    logo: false,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
    fontFamily: "'Montserrat', sans-serif",
    colors: {
      primary: "#1D388D",
      secondary: "#000000B0",
    },
    tancApply: false,
  },
  "jeevan-utthan": {
    logo: `${s3StaticImagePath}/1754651603-lzGJPTUtCt.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap",
    fontFamily: "'Roboto', sans-serif",
    colors: {
      primary: "#8165F8",
      secondary: "#000000",
    },
    tancApply: false,
  },
  inforts: {
    logo: `${s3StaticImagePath}/1754651641-s8pj0GK2do.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Rubik', sans-serif",
    colors: {
      primary: "#08B7C1",
      secondary: "#505050",
    },
    tancApply: false,
  },
  "1touchpe": {
    logo: `${s3StaticImagePath}/1754651667-YIaTIDOuCi.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700;800&display=swap",
    fontFamily: "'Open Sans', sans-serif",
    colors: {
      primary: "#1D92D0",
      secondary: "#4E4E4E",
    },
    tancApply: false,
  },
  ezeepay: {
    logo: `${s3StaticImagePath}/1754651691-gKpzqhWIzD.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Poppins', sans-serif",
    colors: {
      primary: "#FD6101",
      secondary: "#303289",
    },
    tancApply: false,
  },
  dirsti: {
    logo: `${s3StaticImagePath}/1754651714-JOWFFmEYKt.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  visitmyloan: {
    logo: `${s3StaticImagePath}/1754651758-PYxRqypSwZ.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#147F65",
      secondary: "#070707",
    },
    tancApply: false,
  },
  winoraa: {
    logo: `${s3StaticImagePath}/1754651800-YXHgMQ5USF.jpg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#DB4285",
      secondary: "#1D3885",
    },
    tancApply: false,
  },
  ygocompany: {
    logo: `${s3StaticImagePath}/1754655005-M70jSidnt9.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  nitya_finance: {
    logo: `${s3StaticImagePath}/1754655036-3FWNdiZWXu.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  daypfinance: {
    logo: `${s3StaticImagePath}/1754655060-xPYyzNdESQ.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  aadarsh_finance: {
    logo: `${s3StaticImagePath}/1754655089-60bRZtMIZy.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  realzone: {
    logo: `${s3StaticImagePath}/1754655125-ntjrz2VR12.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  moneyflow: {
    logo: `${s3StaticImagePath}/1754655167-4Djlaxpagi.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Inter', sans-serif",
    colors: {
      primary: "#276FCF",
      secondary: "#070707",
    },
    tancApply: false,
  },
  webpe: {
    logo: `${s3StaticImagePath}/1754655190-qb7Z3Vu8eH.jpeg`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap",
    fontFamily: "'Raleway', sans-serif;",
    colors: {
      primary: "#EE0979",
      secondary: "#212529",
    },
    tancApply: false,
  },
  viren: {
    logo: `${s3StaticImagePath}/1754655215-ruzzSLnt7w.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700&display=swap",
    fontFamily: "'Raleway', sans-serif;",
    colors: {
      primary: "#265e8b",
      secondary: "#898989",
    },
    tancApply: false,
  },
  "moral-e-suvidha": {
    logo: `${s3StaticImagePath}/1754655257-ovS7FtsznY.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Karla:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Karla', sans-serif;",
    colors: {
      primary: "#3F51B5",
      secondary: "#070050",
    },
    tancApply: false,
  },
  yoke: {
    logo: `${s3StaticImagePath}/1754655283-OGx2ISwJz9.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap",
    fontFamily: "'Montserrat', sans-serif",
    colors: {
      primary: "#FE5D14",
      secondary: "#020053",
    },
    tancApply: false,
  },
  indezon: {
    logo: `${s3StaticImagePath}/1754655318-D1VszYw4h6.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700&display=swap",
    fontFamily: "'Rubik', sans-serif",
    colors: {
      primary: "#1160D8",
      secondary: "#27282C",
    },
    tancApply: false,
  },
  dhanvriddhiassurance: {
    logo: `${s3StaticImagePath}/1754655344-ssSX38IWGR.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700&display=swap",
    fontFamily: "'Rubik', sans-serif",
    colors: {
      primary: "#124265",
      secondary: "#444444",
    },
    tancApply: false,
  },
  fivekcr: {
    logo: `${s3StaticImagePath}/1754655399-ikByhGPJkC.png`,
    googleFontsAPI:
      "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap",
    fontFamily: "'Poppins', sans-serif",
    colors: {
      primary: "#414195",
      secondary: "#141415",
    },
    tancApply: false,
  },
};

export default partners;
